import { createReducer } from '@reduxjs/toolkit'
import { Field } from 'interfaces/api/templates.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import { createField, getAllFields, getField, setFieldValidationErrors, setSingleField, updateField } from './actions'

interface FieldsState {
  list: {
    loading: boolean
    items: Field[]
    count: number
  }
  single: {
    loading: boolean
    item: Field | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: FieldsState = {
  list: {
    loading: false,
    items: [],
    count: 0,
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const fieldsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllFields.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllFields.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllFields.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload.results
      state.list.count = payload.count
    })

    .addCase(getField.pending, (state) => {
      state.single.loading = true
    })
    .addCase(getField.rejected, (state) => {
      state.single.loading = false
      state.single.item = null
    })
    .addCase([getField.fulfilled, setSingleField], (state, { payload }) => {
      state.single.loading = false
      state.single.item = payload
    })

    .addCase(setFieldValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([createField.pending, updateField.pending], (state) => {
      state.single.loading = true
    })
    .addCase([createField.rejected, updateField.rejected], (state) => {
      state.single.loading = false
    })
    .addCase([createField.fulfilled, updateField.fulfilled], (state) => {
      state.single.loading = false
    })
})
